import { ApolloClient, InMemoryCache, } from "@apollo/client";
import { NativeStorageInterface, } from "@catchupapplications/utilities";
import { featureCollection, point, polygon, center, inside, } from "@turf/turf";
import { setGeneratedMapStyleJSON, setJSCustomStylingValues, } from "../components/layers/variables/layerStylingValues";
import { GET_BAD_OSM_IDS, GET_CUSTOM_MAP_VALUES, GET_DATA, GET_GEOJSONS, GET_GLOBAL_POI_STYLES, } from "../functions/graphQL/graphQL.functions";
import { GeoJSONEnums, } from "../types/map/map.types";
import { getCookie, isFeatureCollection } from "../utils/helpers";
import { mergeGeoJSONData } from "../utils/mergeFloorData";
import { Campus, CampusCollection } from "./Campus.class";
/**
 * Loads intern CUData and initializes the  Map
 */
export default class DataManager {
    get cuNodes() {
        return this.cuNodes;
    }
    get cuContent() {
        return this._cuContent;
    }
    set cuContent(value) {
        this._cuContent = value;
    }
    get geoJSONCollection() {
        return this._geoJSONCollection;
    }
    _setGeoJSONCollection(type, campusKey, value) {
        var _a;
        this._geoJSONCollection[type][campusKey] = value;
        this._prepareGeoJSONFeatures();
        (_a = this.cuGeoJSONEditor) === null || _a === void 0 ? void 0 : _a.setFloorData(this.getAllGeoJSONForCampus());
    }
    get mapStyleJSON() {
        return this._mapStyleJSON;
    }
    get firstGeoJSONDataLoaded() {
        return this._firstGeoJSONDataLoaded;
    }
    constructor(map, cuEventer, cuData) {
        var _a;
        this.CU_DATA_URL = "https://www.catchup-apps.com/api/sdk/getData.php";
        this.CU_DATA_URL_PUBLIC = "https://www.catchup-apps.com/api/public/app/getData.php";
        this.CU_STYLE_PATH = "https://www.catchup-apps.com/navigationProductData/";
        this.CU_CAMPUS_URL = "https://www.catchup-apps.com/api/public/app/getCampuses.php";
        // private CU_APOLLO_URL: string = "http://localhost:8000/graphql";
        this.CU_APOLLO_URL = "https://www.catchup-apps.com/facility-manager-api/graphql/";
        this.campusCollection = new CampusCollection();
        this._cuContent = new Map();
        this._geoJSONCollection = {
            fetched: {},
            added: {},
            temporary: {},
        };
        // TODO: das wird zwar gesetzt, aber noch nicht richtig verwendet!
        this.geoJSONTimeouts = 0;
        this._mapStylesLoaded = false;
        this._activatedMap = false;
        //@ts-ignore: will maybe used later on
        this._piDataLoaded = false;
        this._gidStylesLoaded = false;
        //@ts-ignore: will maybe used later on
        this._firstGeoJSONDataLoaded = false;
        this.cuFeaturesAbortControllers = new Map();
        this.styleDataAbortController = new AbortController();
        this.piDataAbortController = new AbortController();
        this.nativeStorage = NativeStorageInterface.getInstance({
            deviceType: "iOS",
        });
        this._enrichBuildingFeaturesPoi = (buildings) => {
            console.log("Wir sind in enrichBuildingPoi und die kollektion ist", buildings);
            // console.log("Buildings are", buildings, "type of", typeof buildings);
            const buildingFeatures = [];
            const erroredBuildings = [];
            // Das sind alle Gebäude MIT Räumen. (Duplikate)
            const allBuildingsIdsWithRoomsDubs = Array.from(this.getCuContent("Raum").values()).map((r) => {
                return r.buildingId;
            });
            // Das sind alle Gebäude MIT Stockwerken. (Duplikate)
            const allBuildingsIdsWithStockwerkDubs = Array.from(this.getCuContent("Stockwerk").values()).map((r) => {
                return r.buildingId;
            });
            // console.log(
            //   "alle gebäude mit stockwerken",
            //   allBuildingsIdsWithStockwerkDubs
            // );
            // (Keine Duplikate)
            const allBuildingsIdsWithRooms = [...new Set(allBuildingsIdsWithRoomsDubs)];
            const allBuildingsIdsWithStockwerk = [
                ...new Set(allBuildingsIdsWithStockwerkDubs),
            ];
            const myRooms = this._collectionRoom;
            const campusKey = this.campusCollection.getCurrentCampus().id;
            buildings.forEach((b) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                if (b.campusId !== campusKey)
                    return;
                try {
                    let hasContent = false;
                    let forceHasContent = false;
                    let persistentBuildingFlag = (_a = b.additionalData) === null || _a === void 0 ? void 0 : _a.persistenceBuildingFlag;
                    if (persistentBuildingFlag != null &&
                        persistentBuildingFlag !== "NoChange") {
                        forceHasContent = true;
                        if (persistentBuildingFlag === "Never") {
                            hasContent = true;
                        }
                        this._mapPersistenceBuildingFlag.set((_b = b.globalPoiId) !== null && _b !== void 0 ? _b : b.globalId, persistentBuildingFlag);
                    }
                    if (!forceHasContent &&
                        allBuildingsIdsWithRooms.includes((_c = b.globalPoiId) !== null && _c !== void 0 ? _c : b.globalId))
                        hasContent = true;
                    if (!forceHasContent &&
                        allBuildingsIdsWithStockwerk.includes((_d = b.globalPoiId) !== null && _d !== void 0 ? _d : b.globalId))
                        hasContent = true;
                    if ((_e = b.additionalData) === null || _e === void 0 ? void 0 : _e.visualPolygon) {
                        if (!forceHasContent && myRooms != undefined && !hasContent) {
                            for (let room of myRooms.features) {
                                if (inside(center(room), (_f = b.additionalData) === null || _f === void 0 ? void 0 : _f.visualPolygon)) {
                                    hasContent = true;
                                    break;
                                }
                            }
                        }
                        let correctedFeature = (_g = b.additionalData) === null || _g === void 0 ? void 0 : _g.visualPolygon;
                        if (correctedFeature.properties == null)
                            correctedFeature["properties"] = {};
                        // @deprecated because all buildings will use a StyleId in the future
                        correctedFeature.properties.class = (_h = b.additionalData) === null || _h === void 0 ? void 0 : _h.class;
                        correctedFeature.properties.globalPoiId = (_j = b.globalPoiId) !== null && _j !== void 0 ? _j : b.globalId;
                        correctedFeature.properties.globalId = (_k = b.globalPoiId) !== null && _k !== void 0 ? _k : b.globalId;
                        correctedFeature.id = b.globalPoiId;
                        correctedFeature.properties.styleClasses = b.styleClasses;
                        // Dieses Attribut ist entscheidend, ob das Gebäude bestehen bleibt oder ob es ausgeblendet wird.
                        // @ts-ignore
                        correctedFeature.properties.hasContent = hasContent;
                        buildingFeatures.push(correctedFeature);
                    }
                    else if (b.polygon) {
                        if (!forceHasContent && myRooms != undefined && !hasContent) {
                            for (let room of myRooms.features) {
                                if (inside(center(room), polygon(b.polygon))) {
                                    hasContent = true;
                                    break;
                                }
                            }
                        }
                        buildingFeatures.push(polygon(b.polygon, {
                            class: (_l = b.additionalData) === null || _l === void 0 ? void 0 : _l.class,
                            globalPoiId: (_m = b.globalPoiId) !== null && _m !== void 0 ? _m : b.globalId,
                            globalId: (_o = b.globalPoiId) !== null && _o !== void 0 ? _o : b.globalId,
                            // Dieses Attribut ist entscheidend, ob das Gebäude bestehen bleibt oder ob es ausgeblendet wird.
                            hasContent: hasContent,
                        }, { id: (_p = b.globalPoiId) !== null && _p !== void 0 ? _p : b.globalId }));
                    }
                }
                catch (e) {
                    erroredBuildings.push({ building: b, error: e });
                }
            });
            return [buildingFeatures, erroredBuildings];
        };
        this._enrichBuildingFeaturesGeoJson = (buildings) => {
            // console.log("Buildings are", buildings, "type of", typeof buildings);
            const buildingFeatures = [];
            const erroredBuildings = [];
            // Das sind alle Gebäude MIT Inhalten. (Duplikate)
            const allBuildingsIdsWithContentDubs = Array.from(this.getCuContent("Raum").values()).map((r) => {
                return r.buildingId;
            });
            // (Keine Duplikate)
            const allBuildingsIdsWithContent = [
                ...new Set(allBuildingsIdsWithContentDubs),
            ];
            const allBuildingsIdsWithStockwerkDubs = Array.from(this.getCuContent("Stockwerk").values()).map((r) => {
                return r.buildingId;
            });
            const allBuildingsIdsWithStockwerk = [
                ...new Set(allBuildingsIdsWithStockwerkDubs),
            ];
            const myRooms = this._collectionRoom;
            buildings.forEach((b) => {
                var _a, _b;
                let currentGlobalId = (_a = b.properties.globalPoiId) !== null && _a !== void 0 ? _a : b.properties.globalId;
                try {
                    let hasContent = false;
                    let forceHasContent = false;
                    // Geht hier nicht, ist nicht da.
                    // let persistentBuildingFlag = b.additionalData?.persistenceBuildingFlag;
                    let persistentBuildingFlag = this._mapPersistenceBuildingFlag.get(currentGlobalId);
                    if (persistentBuildingFlag != null &&
                        persistentBuildingFlag !== "NoChange") {
                        forceHasContent = true;
                        if (persistentBuildingFlag === "Never") {
                            hasContent = true;
                        }
                    }
                    if (!forceHasContent &&
                        allBuildingsIdsWithContent.includes(currentGlobalId))
                        hasContent = true;
                    if (!forceHasContent &&
                        allBuildingsIdsWithStockwerk.includes(currentGlobalId))
                        hasContent = true;
                    if (!forceHasContent && myRooms != undefined && !hasContent) {
                        for (let room of myRooms.features) {
                            if (inside(center(room), b.geometry)) {
                                hasContent = true;
                                break;
                            }
                        }
                    }
                    let correctedFeature = b;
                    if (correctedFeature.properties == null)
                        correctedFeature["properties"] = {};
                    // @deprecated because all buildings will use a StyleId in the future
                    correctedFeature.properties.class = (_b = b.additionalData) === null || _b === void 0 ? void 0 : _b.class;
                    correctedFeature.properties.globalPoiId = currentGlobalId;
                    correctedFeature.properties.globalId = currentGlobalId;
                    correctedFeature.id = currentGlobalId;
                    correctedFeature.properties.styleClasses = b.styleClasses;
                    // Dieses Attribut ist entscheidend, ob das Gebäude bestehen bleibt oder ob es ausgeblendet wird.
                    // @ts-ignore
                    correctedFeature.properties.hasContent = hasContent;
                    buildingFeatures.push(correctedFeature);
                }
                catch (e) {
                    erroredBuildings.push({ building: b, error: e });
                }
            });
            return [buildingFeatures, erroredBuildings];
        };
        this._mountingData = cuData;
        this._eventer = cuEventer;
        this._map = map;
        this.piData = cuData.piData;
        this.loadUnpublishedPiData = !!cuData.loadUnpublishedPIData;
        this.loadUnpublishedGeoJSONData = !!cuData.loadUnpublishedGeoJSONData;
        this.loadUnpublishedStyleMappings = !!cuData.loadUnpublishedStyleMappings;
        this.loadUnpublishedGidData = !!cuData.loadUnpublishedGidData;
        if (cuData.devMode) {
            if (cuData.devMode.CU_CAMPUS_URL) {
                this.CU_CAMPUS_URL = cuData.devMode.CU_CAMPUS_URL;
            }
            if (cuData.devMode.CU_DATA_URL) {
                this.CU_DATA_URL = cuData.devMode.CU_DATA_URL;
            }
            if (cuData.devMode.CU_STYLE_PATH) {
                this.CU_STYLE_PATH = cuData.devMode.CU_STYLE_PATH;
            }
            if (cuData.devMode.CU_APOLLO_URL) {
                this.CU_APOLLO_URL = cuData.devMode.CU_APOLLO_URL;
            }
            if (cuData.devMode.CU_DATA_URL_PUBLIC) {
                this.CU_DATA_URL_PUBLIC = cuData.devMode.CU_DATA_URL_PUBLIC;
            }
        }
        if (cuData.apolloClient) {
            this.client = cuData.apolloClient;
        }
        else {
            this.client = new ApolloClient({
                uri: this.CU_APOLLO_URL,
                cache: new InMemoryCache(),
                headers: {
                    authorization: (_a = getCookie("SESSION_TOKEN")) !== null && _a !== void 0 ? _a : "no-token-found",
                },
            });
        }
        this._mapPersistenceBuildingFlag = new Map();
    }
    init(setBadOsmIds) {
        this.fetchPiData();
        this._fetchCUMapStyles(setBadOsmIds);
        this._eventer.subscribe("campusChange", "fetchGeoJSONs", () => {
            this.fetchCUGeoJSONs();
        });
    }
    /** Fires functions, which are dependend on multiple different data sources. */
    asyncDataEvents(type) {
        const fetchImagesFromMapStyle = () => {
            if (this._mapStylesLoaded && this._map.cuMapLoaded) {
                this.fetchImagesFromMapStyle();
            }
        };
        switch (type) {
            case "geoJSONLoaded":
                this._firstGeoJSONDataLoaded = true;
                this._eventer.fireEvent("geoJSONLoaded");
                break;
            case "mapStyles":
                this._mapStylesLoaded = true;
                this._eventer.fireEvent("customStylingValuesLoaded", {
                    customValues: true,
                });
                fetchImagesFromMapStyle();
                break;
            case "mapLoaded":
                fetchImagesFromMapStyle();
                break;
            case "piData":
                this._piDataLoaded = true;
                this._eventer.fireEvent("piDataLoaded");
                this.runPiDataDependends();
                // this._map.activateMap();
                break;
            case "piDataRefetch":
                this._piDataLoaded = true;
                this._eventer.fireEvent("piDataLoaded");
                this.runPiDataDependends();
                break;
            case "gidStylesLoaded":
                this._gidStylesLoaded = true;
                break;
        }
        // This is a timing fix.
        if (this._piDataLoaded &&
            this._mapStylesLoaded &&
            !this._activatedMap &&
            this._gidStylesLoaded) {
            // if (this._piDataLoaded && this._mapStylesLoaded && !this._mapLoaded) {
            // this._map.cuMapEditor.toggleAllMarker(true);
            this._map.activateMap();
            this._activatedMap = true;
            console.log("Activated map!");
        }
    }
    // ---- Fetch Data ----
    /**
     * Loads essential data used for creating campuses, floors and more
     */
    fetchPiData() {
        const prepareAddressMarker = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const exceptions = [
                "KGU-iKGHLcCPf0pc3a8DKBPt2g0GqwGGOKvXImE3GFkoUMcHr0",
                "CHARITE-TSoy685nOBSlaybNxKJwwhTBkTxTvRrmfH9n7NtGeR6zv4mjue",
                "Charite-e15fc400-0de8-4625-893f-c1609cc0a8e9",
                "Carlswerk-Koe-c2f2f1b6-16d3-43b0-82eb-53e99a1c2622",
            ];
            const exceptionAddressMarkersAndBuildingMarkers = [
                "IPM-IoEr94wWLMPddQQ6hlVhayNqHzJ7TOt3zYPbA2r05YfN9h",
            ];
            if (((_a = this.piData) === null || _a === void 0 ? void 0 : _a.produktinstanz.produktinstanzKey) != null &&
                exceptions.includes((_b = this.piData) === null || _b === void 0 ? void 0 : _b.produktinstanz.produktinstanzKey)) {
                (_c = this.cuGeoJSONEditor) === null || _c === void 0 ? void 0 : _c.setShowOnlyAddressMarker(true);
                console.log("Using AddressMarkers instead of BuildingMarkers.");
            }
            else if (((_d = this.piData) === null || _d === void 0 ? void 0 : _d.produktinstanz.produktinstanzKey) != null &&
                exceptionAddressMarkersAndBuildingMarkers.includes((_e = this.piData) === null || _e === void 0 ? void 0 : _e.produktinstanz.produktinstanzKey)) {
                (_f = this.cuGeoJSONEditor) === null || _f === void 0 ? void 0 : _f.setShowAddressMarkersAndBuildingMarkers(true);
                console.log("Using AddressMarkers AND BuildingMarkers.");
            }
            const getAllCampusNodes = this.campusCollection.getAllCampusNodes();
            const addressLabels = [];
            const poiLabels = [];
            this.piData.content.forEach((item) => {
                var _a;
                if (item.type === "Adresse") {
                    const myNodeId = item.nodeId;
                    let myNode = undefined;
                    if (myNodeId != null) {
                        myNode = getAllCampusNodes.get(myNodeId);
                        if (myNode == null)
                            return;
                        let addressLabel = {
                            properties: {
                                ...myNode.properties,
                                ...item,
                            },
                            geometry: myNode === null || myNode === void 0 ? void 0 : myNode.geometry,
                            id: myNode === null || myNode === void 0 ? void 0 : myNode.id,
                            type: myNode === null || myNode === void 0 ? void 0 : myNode.type,
                            bbox: myNode === null || myNode === void 0 ? void 0 : myNode.bbox,
                        };
                        addressLabels.push(addressLabel);
                    }
                }
                else if (item.type === "Einrichtung" || item.type === "POI") {
                    // Hier akzeptieren wir jetzt beides.
                    if (item.styleClasses != null) {
                        const myNodeId = item.nodeId;
                        let myNode = undefined;
                        if (myNodeId != null) {
                            myNode = getAllCampusNodes.get(myNodeId);
                            if (myNode == null)
                                return;
                            let poiLabel = {
                                properties: {
                                    instituteGlobalId: (_a = item.globalPoiId) !== null && _a !== void 0 ? _a : item.globalId,
                                    ...myNode.properties,
                                    ...item,
                                },
                                geometry: myNode === null || myNode === void 0 ? void 0 : myNode.geometry,
                                id: myNode === null || myNode === void 0 ? void 0 : myNode.id,
                                type: myNode === null || myNode === void 0 ? void 0 : myNode.type,
                                bbox: myNode === null || myNode === void 0 ? void 0 : myNode.bbox,
                            };
                            poiLabels.push(poiLabel);
                        }
                    }
                }
            });
            (_g = this.cuGeoJSONEditor) === null || _g === void 0 ? void 0 : _g.setSaveAddressMarker(addressLabels);
            (_h = this.cuGeoJSONEditor) === null || _h === void 0 ? void 0 : _h.setSavePoiMarker(poiLabels);
        };
        const preparePiData = () => {
            try {
                if (!this.piData) {
                    // cannot happen though
                    console.warn("No PiData loaded");
                    return undefined;
                }
                if (!this.piData.campus || !this.piData.campus.length) {
                    console.error("No campuses found -> Cannot render Pi specific data", this.piData);
                    return undefined;
                }
                this.piData.campus.forEach((campus) => {
                    var _a, _b, _c;
                    campus;
                    // seek campus from content
                    const contentCampus = (_a = this.piData) === null || _a === void 0 ? void 0 : _a.content.filter((c) => {
                        return (c.campusId === campus.campusinformationen.campusId &&
                            c.type === "Campus");
                    });
                    let polygonFeature;
                    if (contentCampus && contentCampus[0] && contentCampus[0].polygon) {
                        polygonFeature = polygon(contentCampus[0].polygon);
                    }
                    const nodes = new Map();
                    campus.graph.knoten.forEach((n) => {
                        nodes.set(n.id, point([n.coord[1], n.coord[0]], { level: n.coord[2], id: n.id }, { id: n.id }));
                    });
                    this.campusCollection.addCampus(new Campus(campus.campusinformationen.campusId, campus.campusinformationen.campusKey, campus.campusinformationen.campusName, nodes, campus.beacons, campus.campusinformationen.stockwerke, {
                        lat: +campus.campusinformationen.centerLat,
                        lng: +campus.campusinformationen.centerLng,
                    }, polygonFeature, !!campus.campusinformationen.raumnummernAnzeigen, !!campus.campusinformationen.showOutdoorEinrichtungenOnMap, !!campus.campusinformationen.showAdressenOnMap));
                    if (campus.campusinformationen.mapstyleV5) {
                        this._map.CU_MAPSTYLE_URL = campus.campusinformationen.mapstyleV5;
                    }
                    else if ((_b = campus.campusinformationen.stockwerke[0]) === null || _b === void 0 ? void 0 : _b.mapstyle) {
                        this._map.CU_MAPSTYLE_URL =
                            campus.campusinformationen.stockwerke[0].mapstyle;
                    }
                    const cuContent = new Map();
                    (_c = this.piData) === null || _c === void 0 ? void 0 : _c.content.forEach((content) => {
                        var _a;
                        cuContent.set((_a = content.globalPoiId) !== null && _a !== void 0 ? _a : content.globalId, {
                            ...content,
                        });
                    });
                    this.cuContent = cuContent;
                });
                prepareAddressMarker();
                return { prepared: true, e: undefined };
            }
            catch (error) {
                return { prepared: false, e: error };
            }
        };
        const givenCampusKeys = this._mountingData.campusKeys && this._mountingData.campusKeys.length
            ? this._mountingData.campusKeys
            : null;
        const getArrayFromFetchedKeys = (json) => {
            return json.campuses.map((c) => {
                return c.campusKey;
            });
        };
        const _fetch = (campusKeys) => {
            let dataURL;
            if (this._mountingData.catchupSDKKey != null) {
                // Map-sdk-key available so private (or unpublished) data CAN be loaded
                dataURL = `${this.CU_DATA_URL}?Catchup-SDK-Key=${this._mountingData.catchupSDKKey}&locale=${this._mountingData.language}&piKey=${this._mountingData.piKey}&version=${this._mountingData.version}&loadUnpublishedData=${this.loadUnpublishedPiData}&campusKeys=${JSON.stringify(campusKeys)}`;
            }
            else {
                // no sdk-key so only public data can be loaded!
                dataURL = `${this.CU_DATA_URL_PUBLIC}?locale=${this._mountingData.language}&piKey=${this._mountingData.piKey}&version=${this._mountingData.version}&campusKeys=${JSON.stringify(campusKeys)}`;
            }
            fetch(dataURL, { signal: this.piDataAbortController.signal })
                .then((response) => {
                return response.json();
            })
                .then((response) => {
                if (response.status === "SF") {
                    console.error("Serverdaten für die App konnten nicht geladen werden", response.status);
                    this._eventer.fireEvent("serverDataError", response);
                }
                else {
                    this.piData = response;
                    this.nativeStorage.set("mapsdk_piData", response);
                    const dataPrepared = preparePiData();
                    if (dataPrepared === null || dataPrepared === void 0 ? void 0 : dataPrepared.prepared) {
                        this.asyncDataEvents("piData");
                    }
                    else {
                        console.log(dataPrepared === null || dataPrepared === void 0 ? void 0 : dataPrepared.e);
                        this._eventer.fireEvent("serverDataError", dataPrepared === null || dataPrepared === void 0 ? void 0 : dataPrepared.e);
                    }
                }
            })
                .catch((e) => {
                console.error("PiData for app could not be loaded.");
                this._eventer.fireEvent("serverDataError", e);
                // try to get from localstorage
                this.nativeStorage
                    .get("mapsdk_piData")
                    .then((r) => {
                    try {
                        this.piData = r;
                        const dataPrepared = preparePiData();
                        if (dataPrepared === null || dataPrepared === void 0 ? void 0 : dataPrepared.prepared) {
                            this.asyncDataEvents("piData");
                            console.log("Working (but maybe outdated) PiData was retrieved from storage");
                        }
                    }
                    catch (e) {
                        console.error("PiData from storage could not be prepared. Please review data: ", r, "and error:", e);
                    }
                })
                    .catch((e) => {
                    throw e;
                });
            });
        };
        if (givenCampusKeys) {
            if (this.piData != null) {
                const dataPrepared = preparePiData();
                if (dataPrepared === null || dataPrepared === void 0 ? void 0 : dataPrepared.prepared) {
                    this.asyncDataEvents("piData");
                    console.log("Working PiData was retrieved from Upstream Application!");
                }
            }
            else {
                _fetch(givenCampusKeys);
            }
        }
        else {
            // if no keys are given, fetch all available keys
            fetch(`${this.CU_CAMPUS_URL}?piKey=${this._mountingData.piKey}`)
                .then((response) => response.json())
                .then((json) => {
                this.nativeStorage.set("mapsdk_campusKeys", json);
                _fetch(getArrayFromFetchedKeys(json));
            })
                .catch((error) => {
                this.nativeStorage.get("mapsdk_campusKeys").then((json) => {
                    _fetch(getArrayFromFetchedKeys(json));
                });
                this._eventer.fireEvent("campusKeysFetchError", error);
            });
        }
    }
    async fetchPiDataGraphQl() {
        const givenCampusKeys = this._mountingData.campusKeys && this._mountingData.campusKeys.length
            ? this._mountingData.campusKeys
            : null;
        const preparePiDataRefetched = () => {
            var _a;
            (_a = this.piDataRefetched) === null || _a === void 0 ? void 0 : _a.campus.forEach((campus) => {
                this.campusCollection.campuses.forEach((campus2) => {
                    if (campus.campusinformationen.campusKey == campus2.campusKey) {
                        campus2.floors = campus.campusinformationen.stockwerke;
                    }
                });
            });
        };
        const _fetch = (campusKeys) => {
            return this.client.query({
                query: GET_DATA,
                variables: {
                    piKey: this._mountingData.piKey,
                    campusKeys: campusKeys,
                },
            });
        };
        if (givenCampusKeys) {
            const response = await _fetch(givenCampusKeys);
            let responseDetail = response.data.getData;
            this.piDataRefetched = responseDetail;
            preparePiDataRefetched();
        }
    }
    /** Get content by type */
    getCuContent(type) {
        const returnValue = new Map();
        this.cuContent.forEach((value) => {
            if (value.type === type || type === "all") {
                returnValue.set(value.globalPoiId, value);
                returnValue.set(value.globalId, value);
            }
        });
        return returnValue;
    }
    /** The functions called here need the piData to be loaded, before they can be run */
    runPiDataDependends() {
        this._eventer.initCampusChangeEvent();
        clearInterval(this.piInterval);
        // @ts-ignore
        this.piInterval = setInterval(() => {
            if (this._map.loaded() && this._map.isStyleLoaded()) {
                this.fetchCUGeoJSONs();
                clearInterval(this.piInterval);
            }
        }, 50);
    }
    /**
     * Sets StyleIds to the features' properties and updates them on the map
     * with these new features. The styleId Stylings are fetched also and then set
     * as Paint/Layout Props in the {@link LayerSourceManager}
     * @param styleIds: Map<Key: globalPoiId, Value: styleId> - Assigns style Ids from the POIs and overwrites these if give a
     * styleId Map
     */
    setStyleIdsToFeatures(styleIds) {
        var _a;
        const campusGeoJSONs = this.getAllGeoJSONForCampus();
        const appendStyleIdToFeatures = (features) => {
            let errors = 0;
            features.forEach((feature) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                try {
                    if (!feature)
                        return;
                    const globalId = (_b = (_a = feature.properties) === null || _a === void 0 ? void 0 : _a.globalPoiId) !== null && _b !== void 0 ? _b : (_c = feature.properties) === null || _c === void 0 ? void 0 : _c.globalId;
                    if (globalId != null) {
                        const poi = this.cuContent.get(globalId);
                        // Assign StyleId and Level from POI
                        if (poi != null) {
                            if (!feature.properties) {
                                feature.properties = { level: 0 };
                            }
                            // HASHTAG YOLO
                            if (feature.properties.level == null) {
                                feature.properties.level = poi.level;
                            }
                            feature.properties.name = (_d = poi.short) !== null && _d !== void 0 ? _d : poi.name;
                            if (this.loadUnpublishedGidData) {
                                if ((_e = this._gidStyleMap) === null || _e === void 0 ? void 0 : _e.get((_f = poi.globalPoiId) !== null && _f !== void 0 ? _f : poi.globalId)) {
                                    feature.properties.styleId = (_g = this._gidStyleMap) === null || _g === void 0 ? void 0 : _g.get((_h = poi.globalPoiId) !== null && _h !== void 0 ? _h : poi.globalId);
                                }
                            }
                            else if (poi.styleClasses) {
                                if (this.loadUnpublishedStyleMappings) {
                                    if (poi.styleClasses.unpublished) {
                                        feature.properties.styleId = poi.styleClasses.unpublished;
                                    }
                                }
                                else if (poi.styleClasses.published) {
                                    feature.properties.styleId = poi.styleClasses.published;
                                }
                            }
                        }
                        // Overwrite if given styleIds
                        if (styleIds) {
                            const styleId = styleIds.get(globalId);
                            if (styleId) {
                                feature.properties.styleId = styleId;
                            }
                        }
                    }
                }
                catch (e) {
                    if (errors < 10) {
                        console.warn("setting styleId to feature errored.", feature, e);
                        if (errors === 9) {
                            console.warn("others features are probably following", features);
                        }
                    }
                    errors++;
                }
            });
        };
        for (const key in campusGeoJSONs) {
            const features = campusGeoJSONs[key];
            appendStyleIdToFeatures(features);
        }
        if (styleIds) {
            // if explicitly called from outside setFloorData right away!
            (_a = this.cuGeoJSONEditor) === null || _a === void 0 ? void 0 : _a.setFloorData(campusGeoJSONs);
        }
        return campusGeoJSONs;
    }
    /**
     * Extends Feature Properties using POIs with the corresponding globalPoiId.
     * Sets the styleIds.
     */
    _prepareGeoJSONFeatures() {
        try {
            const contentAndGeoJSONsSet = this.cuContent.size &&
                Object.keys(this.geoJSONCollection.fetched).length;
            if (!contentAndGeoJSONsSet)
                return;
            const combinedCollection = this.getAllGeoJSONForCampus();
            const setUniqueIdsForFeatures = (data) => {
                // Some geojsons are false and have mistakenly multiple ids for their features
                // they have to be corrected, else a selection of features will not work properly
                for (const key in data) {
                    const value = data[key];
                    if (value && isFeatureCollection(value) === "featureArray") {
                        value.forEach((f, i) => {
                            f.id = i;
                        });
                    }
                }
            };
            setUniqueIdsForFeatures(combinedCollection);
            this.setStyleIdsToFeatures();
        }
        catch (e) {
            console.error("Something went wrong at setPOIStyleClassesToGeoJSON in the MapSDK. Not all GeoJSONs could be mapped with the corresponding Classname.", e);
        }
    }
    _getBuildingFeaturesFromPoiData() {
        const buildings = this.getCuContent("Gebäude");
        const [buildingFeatures, erroredBuildings] = this._enrichBuildingFeaturesPoi(buildings);
        if (erroredBuildings.length) {
            console.warn("Some buildings errored when trying to prepare for the maprendering. Please review the corrupt buildings.", erroredBuildings);
        }
        return buildingFeatures;
    }
    /**
     * Get CU Features by the GlobalPoiId
     * @param globalPoiId
     * @returns
     */
    getCuFeature(globalPoiId, source = "rooms") {
        // TODO: make this method a lil more general, so it can also get buildings and other stuff
        let foundRoom = null;
        for (const typeKey in this._geoJSONCollection) {
            const geoJSONValue = this._geoJSONCollection[typeKey];
            for (const campusKey in geoJSONValue) {
                const campusValue = geoJSONValue[campusKey];
                const key = source;
                const features = campusValue[key];
                if (features) {
                    const takeR = (r) => {
                        var _a;
                        if (((_a = r.properties.globalPoiId) !== null && _a !== void 0 ? _a : r.properties.globalId) ===
                            globalPoiId) {
                            foundRoom = r;
                            return true;
                        }
                        return false;
                    };
                    if ("features" in features) {
                        features.features.find(takeR);
                    }
                    else {
                        features.find(takeR);
                    }
                }
                if (foundRoom) {
                    break;
                }
            }
            if (foundRoom) {
                break;
            }
        }
        return foundRoom;
    }
    abortFetches() {
        this.styleDataAbortController.abort();
        this.piDataAbortController.abort();
    }
    /**
     * Loads Colors and Properties for the CU Features
     */
    async _fetchCUMapStyles(setBadOsmIds) {
        let customStylePath;
        const getStylepath = () => {
            if (this._mountingData.styleId == null) {
                // wenn keine CustomId aus der URL geholt werden kann -> normaler design Ordner
                customStylePath =
                    this.CU_STYLE_PATH + `${this._mountingData.piKey}/design/`;
            }
            else {
                // bei customId -> custom Design Ordner
                customStylePath =
                    this.CU_STYLE_PATH +
                        `${this._mountingData.piKey}/design/${this._mountingData.styleId}/`;
            }
        };
        const getStyle = async () => {
            const colorsJSONPath = customStylePath + "jsColors/mainColors.json";
            // TODO: old fetch and new fetch. Someday the old fetch has to be removed completely
            fetch(colorsJSONPath, { signal: this.styleDataAbortController.signal })
                .then((result) => {
                return result.json();
            })
                .then((json) => {
                setJSCustomStylingValues(json);
                this._eventer.fireEvent("customStylingValuesLoaded", {
                    deprecatedValues: true,
                });
                this.nativeStorage.set("mapsdk_mapstyles_old", json);
            })
                .catch((error) => {
                // Load from storage
                this.nativeStorage.get("mapsdk_mapstyles_old").then((json) => {
                    setJSCustomStylingValues(json);
                    this._eventer.fireEvent("customStylingValuesLoaded", {
                        deprecatedValues: true,
                    });
                    console.log("Mapstyles_old loaded from storage", json);
                });
                this._eventer.fireEvent("customStylesFetchError", error);
            });
            // this is the new fetch, which is supposed to be the only one!
            this.client
                .query({
                query: GET_CUSTOM_MAP_VALUES,
                variables: {
                    piKey: this._mountingData.piKey,
                    published: !this.loadUnpublishedStyleMappings,
                },
            })
                .then((r) => {
                // throw "This is an error";
                this.nativeStorage.set("mapsdk_mapstyles", r);
                setGeneratedMapStyleJSON(r.data.mapStyleJSON);
                this._mapStyleJSON = r.data.mapStyleJSON;
                this.asyncDataEvents("mapStyles");
            })
                .catch((e) => {
                console.warn("There has been an Error fetching the custom styles for the map", e);
                this.nativeStorage.get("mapsdk_mapstyles").then((r) => {
                    setGeneratedMapStyleJSON(r.data.mapStyleJSON);
                    this._mapStyleJSON = r.data.mapStyleJSON;
                    this.asyncDataEvents("mapStyles");
                    console.log("Mapstyles were loaded from storage", r);
                });
            });
            // Fetch of the HideOsmBuildings.
            const getCampusId = () => {
                let myCampusId = null;
                if (this.campusCollection.getCurrentCampus() != null) {
                    if (this.campusCollection.getCurrentCampus().id != null) {
                        myCampusId = this.campusCollection.getCurrentCampus().id;
                    }
                }
                else {
                    if (this.campusCollection.getCampusByKey(this._mountingData.campusKeys[0]) != null) {
                        if (this.campusCollection.getCampusByKey(this._mountingData.campusKeys[0]).id != null) {
                            myCampusId = this.campusCollection.getCampusByKey(this._mountingData.campusKeys[0]).id;
                        }
                    }
                }
                return myCampusId;
            };
            const doBadOsm = (myCampusId) => {
                // return;
                this.client
                    .query({
                    query: GET_BAD_OSM_IDS,
                    variables: {
                        campusId: myCampusId,
                    },
                })
                    .then((r) => {
                    // console.log("BAD OSM", r);
                    if (r.data.campusHideOSMBuildings != null) {
                        setBadOsmIds(r.data.campusHideOSMBuildings.featureIds);
                    }
                    // setBadOsmIds([1, 2, 3]);
                    // throw "This is an error";
                    // this.nativeStorage.set("mapsdk_mapstyles", r);
                    // setGeneratedMapStyleJSON(r.data.mapStyleJSON);
                    // this._mapStyleJSON = r.data.mapStyleJSON;
                    // this.asyncDataEvents("mapStyles");
                })
                    .catch((e) => {
                    console.warn("There has been an error fetching bad osm ids.", e);
                    // this.nativeStorage.get("mapsdk_mapstyles").then((r) => {
                    //   setGeneratedMapStyleJSON(r.data.mapStyleJSON);
                    //   this._mapStyleJSON = r.data.mapStyleJSON;
                    //   this.asyncDataEvents("mapStyles");
                    //   console.log("Mapstyles were loaded from storage", r);
                    // });
                });
            };
            // let myCampusId = null;
            // EINMAL RAUS:
            let myCampusId = getCampusId();
            if (myCampusId != null) {
                doBadOsm(myCampusId);
            }
            else {
                console.log("CampusID could not be determined, so try again");
                setTimeout(() => {
                    const myCampusId = getCampusId();
                    if (myCampusId != null) {
                        doBadOsm(myCampusId);
                    }
                }, 5000);
            }
        };
        const getGidStyle = async () => {
            // I'm another useless MK comment! jk. I'm a useless PH comment.
            this.client
                .query({
                query: GET_GLOBAL_POI_STYLES,
                variables: {
                    piKey: this._mountingData.piKey,
                    languageCode: "de_DE",
                },
            })
                .then((r) => {
                this._gidStyleMap = new Map();
                r.data.globalPoiStyles.forEach((entry) => {
                    var _a;
                    (_a = this._gidStyleMap) === null || _a === void 0 ? void 0 : _a.set(entry[0], entry[1]);
                });
                this.asyncDataEvents("gidStylesLoaded"); // Irrelevant? Könnte aber für Race-Condition sorgen.
            })
                .catch((e) => {
                console.warn("There has been an Error fetching the Gid styles for the map", e);
            });
        };
        getStylepath();
        getStyle();
        if (this.loadUnpublishedGidData) {
            getGidStyle();
        }
        else {
            this.asyncDataEvents("gidStylesLoaded");
        }
    }
    /**
     * Loads indoor and outdoor features
     *
     * @param refetchCached Usually this function only fetches geojsons for campusKeys, it didn't fetch before
     *  but with this param as true, it will refetch even the geojsons, that have already been fetched and loaded.
     */
    async fetchCUGeoJSONs(refetchCached = false) {
        var _a;
        const _fetch = () => {
            _abortAllOtherFetches();
            // Das neu ladende GeoJSON im keys Objekt markieren, damit es (bei campuswechsel)
            // aborted werden kann (wenn noch am laden)
            const controller = new AbortController();
            this.cuFeaturesAbortControllers = {
                ...this.cuFeaturesAbortControllers,
                [campusKey]: controller,
            };
            getFromNative();
            this.client
                .query({
                fetchPolicy: refetchCached ? "network-only" : "cache-first",
                query: GET_GEOJSONS,
                variables: {
                    piKey: this._mountingData.piKey,
                    campusKey: campusKey,
                    publicity: this.loadUnpublishedGeoJSONData
                        ? "UNPUBLISHED"
                        : "PUBLISHED",
                },
            })
                .then(_success)
                .catch(_failure);
        };
        const _success = (r) => {
            this.nativeStorage.set("mapsdk_geojsondata_" + campusKey, r);
            console.log("speichern von geojsons in native storage", r);
            const geojsons = r.data;
            _setAfterFetch(geojsons);
        };
        const getFromNative = () => {
            this.nativeStorage
                .get("mapsdk_geojsondata_" + campusKey)
                .then((r) => {
                console.log("daten von native", r.data);
                const geojsons = r.data;
                console.log(`GeoJSONs for campusKey ${campusKey} were loaded from storage`, geojsons);
                _setAfterFetch(geojsons);
            })
                .catch((e) => {
                console.log(`GeoJSONs for campusKey ${campusKey} couldn't be loaded from storage`, e);
            });
        };
        const _failure = (e) => {
            console.log("failure beim geojsons fetch");
            getFromNative();
            console.warn(`GeoJSONS for Campus ("${campusKey}") could not be loaded. Please review following error:`, e);
            this._eventer.fireEvent("geoJSONFetchError", e);
            // TODO: why is this here????
            const emptyData = {
                geoJSONS: { buildings: featureCollection([]) },
            };
            // TODO: why is this here????
            // set emptydata just for the re
            _setAfterFetch(emptyData);
            try {
                const error = e.toJSON();
                // bei timeout nochmal versuchen
                console.log(error);
                if (error.status === 408) {
                    this.geoJSONTimeouts++;
                    console.log("GeoJSON collection timeout #" + this.geoJSONTimeouts);
                    // TODO: muss nochmal sich selbst aufrufen
                }
            }
            catch (e) { }
        };
        const _abortAllOtherFetches = () => {
            for (let key in this.cuFeaturesAbortControllers) {
                // every other loading campus shall be stopped, when a new one has to be loaded first
                const controller = this.cuFeaturesAbortControllers[key];
                if (controller) {
                    controller.abort();
                }
            }
        };
        const _setAfterFetch = (data) => {
            var _a;
            const geojsons = data.geoJSONS;
            if (geojsons) {
                // That has to be done to evade "readonly" bugs caused by apollo
                const collection = JSON.parse(JSON.stringify(geojsons));
                const castedCollection = {
                    ground: collection["ground.geojson.json"],
                    rooms: collection["rooms.geojson.json"],
                    outlines: collection["outline.geojson.json"],
                    floors: collection["floors.geojson.json"],
                    details: collection["details.geojson.json"],
                    masks: collection["masks.geojson.json"],
                    walls: collection["walls.geojson.json"],
                    buildings: collection["buildings.geojson.json"],
                };
                // Setzen einer globalen Variable für den leichten Zugriff später:
                if (castedCollection.rooms != null) {
                    this._collectionRoom = castedCollection.rooms;
                }
                // Kommentar: Das ist kein Fallback, das ist der Standard...
                // Fallback method, in case buildings are not buildings.geojson.json
                const poiBuildingFeatures = this._getBuildingFeaturesFromPoiData();
                // Falls veröffentlichte GeoJsonDaten, und wir PoiBuildingFeatures haben und es nicht bereits Buildings gibt, dann werden Gebäude aus DefaultJson-Daten entnommen.
                if (!this.loadUnpublishedGeoJSONData &&
                    poiBuildingFeatures.length &&
                    !castedCollection.buildings) {
                    castedCollection.buildings = featureCollection(poiBuildingFeatures);
                }
                // Ansonsten nehmen wir dann die Grounds aus den GeoJsons.
                if (this.loadUnpublishedGeoJSONData &&
                    // @ts-ignore
                    castedCollection.ground.features != null) {
                    // Buildings are not stored in GeoJson. They come from DefaultJsons. Execept in this case, here the come from GeoJsons. But they are called ground.
                    // We live in a society.
                    const [resultBuildings, erroredBuildings] = this._enrichBuildingFeaturesGeoJson(
                    // @ts-ignore
                    castedCollection.ground.features);
                    castedCollection.buildings = featureCollection(resultBuildings);
                    console.log("Errored builings:", erroredBuildings);
                }
                // if there are no rooms at all, it has to be an outdated Productinstance,
                // where Raster Images are used for indoor plans. In that case the ground would overlay and hide them.
                // So ground can ONLY be shown, when there are rooms
                if (castedCollection.rooms &&
                    // @ts-ignore Rooms is a collection, get it!
                    ((_a = castedCollection.rooms.features) === null || _a === void 0 ? void 0 : _a.length) != 0) {
                    // It's agreed that the buildings should always be the ground
                    castedCollection.ground = castedCollection.buildings;
                }
                this._setGeoJSONCollection(GeoJSONEnums.fetched, campusKey, castedCollection);
                this.asyncDataEvents("geoJSONLoaded");
            }
            else {
                // Fallback method, in case buildings are not buildings.geojson.json
                const poiBuildingFeatures = this._getBuildingFeaturesFromPoiData();
                this._setGeoJSONCollection(GeoJSONEnums.fetched, campusKey, {
                    buildings: featureCollection(poiBuildingFeatures),
                });
                console.warn(`Geojsons for campus "${campusKey}" are null`);
            }
        };
        const _setWithoutFetch = () => {
            var _a;
            (_a = this.cuGeoJSONEditor) === null || _a === void 0 ? void 0 : _a.setFloorData(this.getAllGeoJSONForCampus());
        };
        const campusKey = (_a = this.campusCollection.getCurrentCampus()) === null || _a === void 0 ? void 0 : _a.campusKey;
        if (!campusKey)
            return;
        const availableGeoJSON = this.geoJSONCollection.fetched[campusKey];
        if (!availableGeoJSON || refetchCached) {
            _fetch();
        }
        else {
            _setWithoutFetch();
        }
    }
    /** The MapStyles contain Images for Iconbackgrounds (later also more) for Building Texts*/
    fetchImagesFromMapStyle() {
        // const textBackgrounds =
        //   generatedMapStyleJSON?.buildings.symbols.images ?? [];
        // textBackgrounds?.forEach((image) => {
        //   this._map.loadAndAddImage(
        //     image.value.url,
        //     "styleId_" + image.styleId,
        //     image.value.options
        //   );
        // });
        // // loadFallback background image for labels
        // this._map.loadAndAddImage(
        //   default_buildingLabelIcon,
        //   "default_buildingLabelIcon",
        //   {
        //     stretchX: [[40, 160]],
        //     stretchY: [[40, 160]],
        //     content: [0, 0, 200, 200],
        //     pixelRatio: 4,
        //   }
        // );
    }
    /**
     * GeoJSON data from fetched/added/temporary of current campus merged into one.
     * @param campusKey Merged data from which campus? Default: current campuskey
     */
    getAllGeoJSONForCampus(campusKey) {
        // Fixes bug.
        if (!campusKey) {
            if (this.campusCollection.getCurrentCampus() != null) {
                campusKey = this.campusCollection.getCurrentCampus().campusKey;
            }
            else {
                campusKey = this._mountingData.campusKeys[0];
            }
        }
        if (this._mountingData.piKey ===
            "UKT-7wbrGmoTcGMsoSHnYvS10mCRTb76Ws1uolN3s5kdLJUj9M" ||
            this._mountingData.piKey ===
                "KBO-oWzPatF6XgbbbXLJpsxGkR5BsFA36VNL6Q8vhrpoFvoNbK") {
            console.log("Overriding campusGeoJsons");
            let allFetched = {};
            // let allAdded = [];
            // let allTemporary = [];
            // Für jeden Eintrag der GeoJson-Fetched-Kollektion
            // Wenn ein Campus geladen wurde, dann sind die "GeoJson"-Strukturen unter dem Campus-Schlüssel abrufbar
            for (const [, camGeoJson] of Object.entries(this.geoJSONCollection.fetched)) {
                // Für jedes Bestandteil der GeoJson (ground, building, ...)
                for (const [sourceName, sourceContent] of Object.entries(camGeoJson)) {
                    if (allFetched[sourceName] != undefined &&
                        allFetched[sourceName]["features"] != undefined) {
                        allFetched[sourceName] = featureCollection([
                            ...allFetched[sourceName].features,
                            ...sourceContent.features,
                        ]);
                    }
                    else {
                        allFetched[sourceName] = sourceContent;
                    }
                }
            }
            if (this._mountingData.piKey ===
                "KBO-oWzPatF6XgbbbXLJpsxGkR5BsFA36VNL6Q8vhrpoFvoNbK") {
                const buildings = this.piData.content
                    .filter((c) => c.type === "Gebäude")
                    .map((b) => b.additionalData.visualPolygon);
                allFetched = { ...allFetched, buildings };
            }
            // Und nun der letzte Schritt: returnen der gemergten Kollektionen.
            // Liefert eine gemergte Kollektion, CampusKeys sind nicht mehr enthalten.
            return mergeGeoJSONData([
                allFetched,
                this.geoJSONCollection.added[campusKey],
                this.geoJSONCollection.temporary[campusKey],
            ]);
        }
        else {
            return mergeGeoJSONData([
                this.geoJSONCollection.fetched[campusKey],
                this.geoJSONCollection.added[campusKey],
                this.geoJSONCollection.temporary[campusKey],
            ]);
        }
    }
}
